module.exports = "/_next/static/images/zec-875bc901d94492eee1c7477d84f7b75c.png";